import Dashboard from "@/common/components/layout/Dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import { useParams } from "react-router-dom";
import { RenterDashboardProvider } from "../renter-dashboard/RenterDashboard.provider";
import Toast from "@/common/components/ui/toast";
import RenterDashboardInstallment from "./RenterDashboardInstallment";


function RenterDetailsInstallment() {
  const { renterId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <RenterDashboardProvider renterId={renterId || ''}>
          <RenterDashboardInstallment />
        </RenterDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default RenterDetailsInstallment